import { z } from "zod";
import { parameterBaseSchema } from "./parameterBase.schema";
import { ParameterTypeEnum } from "./ParameterType.enum";

/**
 * Schema for reference date parameter (and start- and end-date, which share the same functionality, only a different
 * label).
 */
export const referenceDateParameterSchema = parameterBaseSchema.merge(
    z.object({
        type: z.union([
            z.literal(ParameterTypeEnum.REFERENCE_DATE),
            z.literal(ParameterTypeEnum.START_DATE),
            z.literal(ParameterTypeEnum.END_DATE),
        ]),
        possibleValues: z.array(z.string()).optional(),
    })
);
